(ns storrito.instagram.story.post.util
  (:require [clojure.string :as str]))

;; Support for Cyrillic, Greek, Arabic and Smileys :)
(def black-list
  "[\u0000-\u0029
    \u002B-\u002F
    \u00A7
    \u003A-\u0040
    \u007B-\u009F
    \u20A0-\u20FF
    \u2000-\u206F
    \u2200-\u22FF
    \u2300-\u23FF
    \u25A0-\u25FF
    \u2500-\u257F
    \u2580-\u259F
    \uF000-\uF000
    \uFF11-\uFFFF]")

(defn filter-hashtag [text]
  (apply str
         (re-seq
           (re-pattern black-list)
           text)))

(defn valid-hashtag? [text]
  (and
    (< (count text) 30)
    (> (count text) 0)
    (empty? (filter-hashtag text))))

(comment
  (def cyrillic "МОСКВА")
  (def greek "πρςστυφχψωϊϋόύώϏ")
  (def arabic "الجملةالأسمية")
  (def valid-1 "test_123")
  (def invalid-tag1 "Test-123") 
  
  (valid-hashtag? cyrillic)
  (valid-hashtag? invalid-tag1)
  (valid-hashtag? valid-1)
  )

(defn filter-usertag [text]
  (and
    (<= (count text) 30)
    (apply str
           (re-seq #"[A-z0-9_.]"
                   text))))

(defn valid-usertag? [text]
  (and
    (not (str/blank? text))
    (= text
      (filter-usertag text))))

(defn hashtag-object? [fabric-object]
  (str/starts-with?
    (:text fabric-object) "#"))

(defn usertag-object? [fabric-object]
  (str/starts-with?
    (:text fabric-object) "@"))

(comment
  (usertag-object? {:text "#МОСКВА"})
  (usertag-object? {:type "i-text"
                    :text "#МОСКВА"})
  )
